<template>
  <v-container>
    <template v-if="paymentLinksStore.loadingListAllPaymentLinks">
      <v-row class="mt-3 mb-5 mr-1">
        <v-col cols="12" class="d-flex align-center ga-3">
          <v-spacer />
          <v-skeleton-loader v-if="isAdminOrOwner" class="create-link-skeleton" type="button" />
        </v-col>
        <v-col cols="12">
          <v-card class="pa-3 mb-4">
            <v-skeleton-loader class="status-filter-skeleton" type="chip" />
          </v-card>
          <v-skeleton-loader class="border rounded-lg" type="table" />
        </v-col>
      </v-row>
    </template>
    <empty-payment-link-card v-else-if="noLinks" />
    <template v-else>
      <v-row class="mt-3 mb-5 mr-1">
        <v-col cols="12" class="d-flex align-center ga-3">
          <v-spacer />
          <v-btn
            v-if="isAdminOrOwner"
            color="primary"
            prepend-icon="mdi-plus"
            @click="router.push({ path: '/create/paymentLinks' })"
          >
            {{ $t("page.paymentLinks.createPaymentLink") }}
          </v-btn>
        </v-col>
        <v-col cols="12">
          <payment-link-search-filter />
          <payment-link-list-card />
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>

<script lang="ts" setup>
import { computed, onMounted } from "vue";
import EmptyPaymentLinkCard from "@/payment-links/components/payment-link/EmptyPaymentLinkCard.vue";
import PaymentLinkListCard from "@/payment-links/components/payment-link/PaymentLinksListCard.vue";
import PaymentLinkSearchFilter from "@/payment-links/components/payment-link/PaymentLinkSearchFilter.vue";
import { usePaymentLinksStore } from "@/payment-links/stores/paymentLinks";
import { useAuthStore } from "@/auth/stores/auth";
import { useRouter } from "vue-router";

const router = useRouter();
const paymentLinksStore = usePaymentLinksStore();
const isAdminOrOwner = computed(() => {
  return useAuthStore().isOwner || useAuthStore().getRoleName === "admin";
});

onMounted(async () => {
  await paymentLinksStore.getAllPaymentLinks();
});

const noLinks = computed(() => paymentLinksStore.allPaymentLinks.length === 0);
</script>

<style scoped>
.create-link-skeleton {
  width: 190px;
  height: 36px;
  background: transparent;
}

.create-link-skeleton :deep(.v-skeleton-loader__button),
.status-filter-skeleton :deep(.v-skeleton-loader__chip) {
  width: 100%;
  max-width: none;
  margin: 0;
}

.status-filter-skeleton {
  width: 132px;
  height: 32px;
  background: transparent;
}

.status-filter-skeleton :deep(.v-skeleton-loader__chip) {
  border-radius: 4px;
}
</style>
